export const FEATURE_FLAGS_MULTI_ACCOUNTS =
  process.env.REACT_APP_FEATURE_FLAGS_MULTI_ACCOUNTS === 'true';

export const LOAD_MULTI_ACCOUNTS_PARAMS = {
  LIMIT: 50,
  OFFSET: 0,
};

export const MULTI_ACCOUNTS_NOTIFICATION_DURATION = 5000;
